import store from "../../../../store";
import email_editor from './email_editor.vue';


window.email_editor =  new Vue({
    store,
    el: '#email_editor',
    name : "email_editor",
    created () {

    },
    components : {
        email_editor
    }
})
